import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/router/dashboard'
import RMR from '@/router/rmr'
import WH from '@/router/warehouse'
import LOCATION from '@/router/location'
import Material from '@/router/material'
import AuditLog from '@/router/auditlog'
import User from '@/router/user'
import DOAApproval from '@/router/doaapproval'
import Partner from '@/router/partner'
import MaterialType from '@/router/materialtype'
import Justification from '@/router/justification'
import Buyer from '@/router/buyer'
import InvoicePreparation from '@/router/invoicepreparation'
import Maintenance from '@/router/maintenance'
import MaterialGroup from '@/router/materialgroup'
import WasteConstractor from '@/router/wastecontractor'
import Default from '@/router/default'
import Supplier from '@/router/Supplier'
import EmailGroup from '@/router/emailgroup'
import Proposal from '@/router/proposal'
import JdeChildAfe from '@/router/jdechildafe'
import BankAccount  from '@/router/bankaccount'
import Report  from '@/router/report'
import FinalRefurbish  from '@/router/finalrefurbish'
import IssueCleaningItem  from '@/router/issuecleaningitem'
Vue.use(Router)
const routes = [
  Dashboard,
  RMR,
  LOCATION,
  WH,
  Material,
  AuditLog,
  User,
  DOAApproval,
  Partner,
  MaterialType,
  Justification,
  Buyer,
  InvoicePreparation,
  Maintenance,
  Default,
  MaterialGroup,
  WasteConstractor,
  Supplier,
  EmailGroup,
  Proposal,
  JdeChildAfe,
  BankAccount,
  Report,
  FinalRefurbish,
  IssueCleaningItem
]

const router = new Router({
  scrollBehavior: () => ({ y: 0 }), // Auto scroll to top when change the route
  routes
  // mode: 'history', // Required for Adal library
})
export default router
